import { DynamicLayout, formBuilderConstants } from '../../formbuilder';
import { newStepValue } from '../../../../services/flowBuilder/utils/constants';

const match = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'regularExpression',
      actionParams: {
        variableName: '',
        function: '',
        pattern: '',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.variableName',
    'action.actionParams.function',
    'action.actionParams.pattern',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.variableName',
        'action.actionParams.function',
        'action.actionParams.pattern',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
};

const replaceFirst_All = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'regularExpression',
      actionParams: {
        variableName: '',
        function: '',
        pattern: '',
        replace: '',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.variableName',
    'action.actionParams.function',
    'action.actionParams.pattern',
    'action.actionParams.replace',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.variableName',
        'action.actionParams.function',
        'action.actionParams.pattern',
        'action.actionParams.replace',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
};

export const regularExpression: DynamicLayout = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'regularExpression',
      actionParams: {
        variableName: '',
        function: '',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.variableName',
    'action.actionParams.function',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.variableName',
        'action.actionParams.function',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    variableName: {
      type: 'text',
      label: 'Variable Name',
      validators: {
        required: true,
      },
    },
    pattern: {
      type: 'text',
      label: 'Pattern',
      validators: {
        required: true,
      },
    },
    replace: {
      type: 'text',
      label: 'Replace',
      validators: {
        required: false,
      },
    },
    result: {
      dataType: 'keyValue',
      key: {
        attributes: {
          readonly: true,
        },
        type: 'text',
        label: '#',
      },
      value: {
        attributes: {
          // readonly: false
        },
        type: 'next',
        label: 'Point to',
      },
    },
    function: {
      type: 'dropdown',
      label: 'Function',
      attributes: {
        options: {
          [formBuilderConstants.DEFAULT_SELECT_OPTION_VALUE]:
            formBuilderConstants.DEFAULT_SELECT_OPTION_DESCRIPTION,
          match: 'Match',
          replaceFirst: 'Replace First',
          replaceAll: 'Replace All',
        },
        data: true
      },
      validators: {
        optionSelected: true,
      },
    },
  },
  data: {
    dataPath: 'action.actionParams.function',
    function: {
      match: match,
      replaceFirst: replaceFirst_All,
      replaceAll: replaceFirst_All,
    },
  },
};
